import React from 'react'
import { CiBookmarkPlus } from "react-icons/ci";
import { LEASING_TYPES, TYPES } from '../../utils/type';
import moment from "moment";

const NewCard = ({data}) => {
  return (
    <div className='mt-1 bg-white rounded-xl p-3 flex items-center justify-between'>
        <div>
            <h1>Барааны нэр: 
                <span className='font-bold uppercase'>{data.product.name}</span>
                {
                    data.type === TYPES.IRSEN &&
                    <span className='ml-3'>{moment.utc(data.date).format('YYYY-MM-DD')}</span>
                }
            </h1>
            <h1 className=''>Код: <span className='font-bold'>{data.code}</span></h1>
            <h1>Ширхэг: <span className='font-bold uppercase'>{data.too}</span></h1>
            <h1>Карго: <span className='font-bold uppercase'>{Number(data.pay) * Number(data.too)}</span></h1>
            <h1>Үнэ: 
                    {
                        data.prices.id === 1 ?
                        <span className='font-bold uppercase'>{data.product.price}₮</span> 
                        :
                        <span className='font-bold uppercase'>{data.prices.price}₮</span>
                    }
            </h1>
        </div>
        <div>
            <h1 className='flex items-center gap-3'>
                {data.type === TYPES.REQUESTED && (
                    <div className='flex items-center gap-2'>
                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Хүлээгдэж байгаа</h1>
                    </div>
                )}
                {data.type === TYPES.IRSEN && (data.delivery === TYPES.REQUESTED) && (
                    <div className='flex items-center gap-2'>
                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Хүргэлтэнд бүртгүүлсэн</h1>
                    </div>
                )}
                {data.type === TYPES.IRSEN && (!data.delivery || data.delivery === null) && (
                    <div className='flex items-center gap-2'>
                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Ирсэн</h1>
                    </div>
                )}
                {data.type === TYPES.REJECTED && (
                    <div className='flex items-center gap-2'>
                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>{data.leasing === LEASING_TYPES.R ? 'Лизинг цуцлагдсан' : 'Буцаалт хийсэн'}</h1>
                    </div>
                )}
                {data.type === TYPES.CONFIRM && (
                    <div className='flex items-center gap-2'>
                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'> Хүлээлгэж өгсөн {data.delivery === TYPES.CONFIRM && " (хүргэлтээр)"}</h1>
                    </div>
                )}
            </h1>
            {
                data.leasing === LEASING_TYPES.Y &&
                <div className='mt-2 flex justify-end'>
                    <h1 className='text-[10px] text-orange-700 uppercase font-bold border rounded-xl p-1'>Лизингээр захиалсан</h1>
                </div>
            }
        </div>
    </div>
  )
}

export default NewCard